import environmentConfigurators from '#environment/configurators.js';
import axios from 'axios';
import commonConfigurators from './common/configurators.js';
const configurators = [...environmentConfigurators, ...commonConfigurators];
const createClient = (config) => {
    const axiosInstance = axios.create({
        ...config,
        withCredentials: true,
    });
    configurators.forEach((configurator) => configurator(axiosInstance, config));
    return axiosInstance;
};
export { axios, createClient };
export * from 'axios';
export * from 'axios-retry';
//# sourceMappingURL=index.js.map